export class ApiError extends Error {
    status;
    constructor(status, message) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
    }
}
async function request(path, init) {
    const res = await fetch(path, {
        credentials: 'include',
        headers: { 'content-type': 'application/json', ...(init?.headers ?? {}) },
        ...init,
    });
    if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new ApiError(res.status, `HTTP ${res.status} ${path}: ${text.slice(0, 200)}`);
    }
    if (res.status === 204)
        return undefined;
    return res.json();
}
export const api = {
    request,
    authMe: () => request('/api/auth/me'),
    authLogout: () => request('/api/auth/logout', { method: 'POST' }),
};
